import { fromJS } from 'immutable';

import { CREATE_CONNECTION, DESTROY_CONNECTION } from 'OPENTOK/action_types';

export const createConnection = (sessionId, connection) => ({
  type: CREATE_CONNECTION,
  id: connection.connectionId,
  payload: {
    sessionId,
    object: connection,
    createdAt: connection.creationTime,
    data: fromJS(JSON.parse(connection.data)),
  },
});

export const destroyConnection = (connection) => ({
  type: DESTROY_CONNECTION,
  id: connection.connectionId,
});
